import { createSlice } from "@reduxjs/toolkit";
import {
  getAllGeneralDonations,
  getCompletedGeneralDonation,
  getDetailsGeneralDonation,
  getGeneralDonationTypes,
  getHomePageGeneralDonations,
} from "../actions/generalDonations.actions";
import { getDonationTypes } from "../actions/donation.actions";

const initialState = {
  donationTypes: [] as any,
  generalDonationTypes: [] as any,
  generalDonationHomePage: [] as any,
  generalDonations: [] as any,
  completedGeneralDonations: [] as any,
  statusGeneralDonation: "idle" as string,
  detailsGeneralDonation: null as any,
  loading: false,
  error: null as unknown | null,
};
export const generalDonationSlice = createSlice({
  name: "generalDonations",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getHomePageGeneralDonations.pending, (state) => {
        state.statusGeneralDonation = "idle";
      })
      .addCase(getHomePageGeneralDonations.fulfilled, (state, action) => {
        state.generalDonationHomePage = action.payload?.result;
        state.statusGeneralDonation = "succeeded";
      })
      .addCase(getHomePageGeneralDonations.rejected, (state, action) => {
        state.generalDonationHomePage = [];
        state.statusGeneralDonation = "rejected";
        state.error = action.payload;
      })
      .addCase(getAllGeneralDonations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllGeneralDonations.fulfilled, (state, action) => {
        state.generalDonations = action.payload?.result;
        state.loading = false;
      })
      .addCase(getAllGeneralDonations.rejected, (state, action) => {
        state.generalDonations = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCompletedGeneralDonation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompletedGeneralDonation.fulfilled, (state, action) => {
        state.completedGeneralDonations = action.payload?.result;
        state.loading = false;
      })
      .addCase(getCompletedGeneralDonation.rejected, (state, action) => {
        state.completedGeneralDonations = [];
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getGeneralDonationTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGeneralDonationTypes.fulfilled, (state, action) => {
        state.generalDonationTypes = action.payload;
        state.loading = false;
      })
      .addCase(getGeneralDonationTypes.rejected, (state, action) => {
        state.generalDonationTypes = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDonationTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDonationTypes.fulfilled, (state, action) => {
        state.donationTypes = action.payload;
        state.loading = false;
      })
      .addCase(getDonationTypes.rejected, (state, action) => {
        state.donationTypes = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDetailsGeneralDonation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDetailsGeneralDonation.fulfilled, (state, action) => {
        state.detailsGeneralDonation = action?.payload?.data?.result;
        state.loading = false;
      })
      .addCase(getDetailsGeneralDonation.rejected, (state, action) => {
        state.detailsGeneralDonation = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default generalDonationSlice.reducer;
